import React from "react"

import { FORMAT_TEXT_COMMAND } from "lexical"
import { BoldIcon, ItalicIcon, UnderLineIcon, StrikethroughIcon } from "@editor/theme/editorIcons"

import styles from "../toolbarPlugin.module.css"
import { Button, Tooltip } from "@dit/core-frontend"

export const TextFormat = ({
  activeEditor,
  buttonProps,
  isEditable,
  isBold,
  isItalic,
  isStrikethrough,
  isUnderline,
  blockType,
}) => {
  return (
    <>
      <Tooltip content="Применение полужирного начертания к тексту">
        <Button
          {...buttonProps}
          kind="borderless"
          disabled={!isEditable || blockType === "h3"}
          onClick={() => {
            activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold")
          }}
          className={`${styles.boldBtn} ` + (isBold ? ` ${styles.active}` : "")}
        >
          <BoldIcon color={isBold ? "var(--blue-60)" : "#696C71"} />
        </Button>
      </Tooltip>
      <Tooltip content="Применение курсивного начертания к тексту">
        <Button
          {...buttonProps}
          kind="borderless"
          disabled={!isEditable}
          onClick={() => {
            activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic")
          }}
          className={`${styles.italicBtn} ` + (isItalic ? ` ${styles.active}` : "")}
        >
          <ItalicIcon color={isItalic ? "var(--blue-60)" : "#696C71"} />
        </Button>
      </Tooltip>
      <Tooltip content="Подчеркивание текста">
        <Button
          {...buttonProps}
          kind="borderless"
          disabled={!isEditable}
          onClick={() => {
            activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, "underline")
          }}
          className={`${styles.underLineBtn} ` + (isUnderline ? ` ${styles.active}` : "")}
        >
          <UnderLineIcon color={isUnderline ? "var(--blue-60)" : "#696C71"} />
        </Button>
      </Tooltip>
      <Tooltip content="Зачеркивание текста">
        <Button
          {...buttonProps}
          kind="borderless"
          disabled={!isEditable}
          onClick={() => {
            activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, "strikethrough")
          }}
          className={`${styles.StrikeLineBtn} ` + (isStrikethrough ? ` ${styles.active}` : "")}
        >
          <StrikethroughIcon color={isStrikethrough ? "var(--blue-60)" : "#696C71"} />
        </Button>
      </Tooltip>
    </>
  )
}
